import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import ImgNotAvailable from '@/assets/img/image-not-available.png'

import AudioViewer from './AudioViewer'
import PhotoViewer, { PhotoViewerProps } from './PhotoViewer'
import PdfViewer from './PdfViewer'
import VideoViewer from './VideoViewer'
import CsvViewer from './CsvViewer'

export type FilePreviewProps = {
  fileName: string
  /**
   * The file type
   */
  fileType: string
  /**
   * The file source
   */
  filePath: string
  /**
   * Callback fired when loading resource has error
   * @param {unknown} error
   */
  onError?: (error?: unknown) => void
  PhotoViewerProps?: Pick<PhotoViewerProps, 'disableAnnotation' | 'onSave'>
}

function UnsupportedViewer({ fileType }: Pick<FilePreviewProps, 'fileType'>) {
  return (
    <Box>
      <Box>
        <Typography variant="body1" component="p">
          <b>{`.${fileType}`}</b> is not supported.
        </Typography>
      </Box>
    </Box>
  )
}

export default function FilePreview(props: FilePreviewProps) {
  const { fileName, fileType, filePath, onError, PhotoViewerProps: photoViewerProps } = props

  const getViewer = () => {
    switch (fileType) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
        return <PhotoViewer extension={fileType} name={fileName} onError={onError} src={filePath} fallBackSrc={ImgNotAvailable} {...photoViewerProps} />
      case 'webm':
      case 'mp4':
      case 'mkv':
        return <VideoViewer onError={onError} src={filePath} fallBackSrc={ImgNotAvailable} />
      case 'mp3':
      case 'ogg':
        return <AudioViewer src={filePath} />
      case 'pdf':
        return <PdfViewer src={filePath} />
      case 'csv':
        return <CsvViewer onError={onError} src={filePath} />
      default:
        return <UnsupportedViewer fileType={fileType} />
    }
  }

  return getViewer()
}
